// https://patorjk.com/software/taag/#p=display&f=Colossal&t=Math

import {
  ELegoGET,
  EKitInstancePOSTResp,
  SyncWrapper,
  ESkinnyKitGET,
  EUserOrgKitRecentGET,
  EForEachButtonGET,
  Body_create_lego_v1__org_id__command_templates_post,
  ESkinnyKitOutColGET,
  ESkinnyKitOutColGET_OL_NotOurOutputColumn,
  ESkinnyKitInColGET,
  EDecorationPOSTReq,
  EDecorationPOSTResp,
  EDecorationGET,
  EDecorationGET_DecorationColMap,
  ELegoInstanceInputPOSTReq,
  ELegoInstanceInputPATCHReq,
  ELegoInstanceInputPOSTReq_LegoInput,
  EDecorationPATCHReq,
  ENotOurOutputColumnGET,
  EDropdownPATCHReq,
  ELegoInstanceInputGET,
  EDropdownGET,
  EDropdownPOSTReq,
  EDropdownPOSTResp,
  EDeepKit3GET,
  EDeepKit3GET_LegoInstanceInput,
  EDeepKit3GET_LII_LegoInput,
  EDeepKit3GET_KitInstance,
  EDeepKit3GET_KI_Kit,
  ELegoPATCHReq,
  EDeepKit3GET_Kit_2,
  EDeepKit3GET_K_KitInstance,
  EDeepKit3GET_K_KI_Kit,
  EDeepKit3GET_KI_K_LegoInstanceInput,
  EDeepKit3GET_K_KI_K_LegoInstanceInput,
  EDeepKit3GET_K_LegoInstanceInput,
  EDeepKit3GET_KI_K_LII_LegoInput,
  EDeepKit3GET_K_LII_LegoInput,
  EDeepKit3GET_K_KI_K_LII_LegoInput,
  EKitInstancePOSTReq,
  EDeepKit3GET_Decoration,
  EDeepKit3GET_K_Decoration,
  EDeepKit3GET_OL_NotOurOutputColumn,
  EDeepKit3GET_K_OL_NotOurOutputColumn,
  ESkinnyKitInColGET_LegoInstanceInput,
  EDeepKit3GET_VariableLink,
  EDeepKit3GET_K_VariableLink,
} from "../types/api-schema";
import {
  KitRunSchemaElement,
  ApiRequest,
  HttpMethod,
  InstanceSchemaElement,
  KitVisibility,
  ExecutionEnv,
  initDropdownDoll,
  DropdownDoll,
} from "../types/general-flank-types";
import {
  pathRest,
  lfind,
  lfindIndex,
  ocopy,
  lcopy,
  lInsertAt,
  lremoveAt,
  lenumerate,
  omerge,
  ovaluemap,
  lgroupBy,
  oitems,
  lot2o,
  oget,
  pathsJoin,
  pathSplit,
  lsort,
  lfirst,
  pyfalsey,
  odiffOldNew,
  pathJoin,
  pyCoalesce,
  pytruthy,
  lunique,
  okeyfilter,
  isArray,
  enforceType,
  ldiffOrderInsensitive,
  lzipBy,
  lsplit,
  lreplace,
  lcontains,
  lmap2oGen,
  okeysGen,
  equals,
  pathFirst,
} from "../brains/flang";
import {
  bindFlatParamsToSchema,
  injectLegoSchemaIntoKitRunSchema,
  setSchemaValuesToDefaults,
  replaceElementInSchema,
  trimDownSchema,
  strToRunrams,
  runramsToStr,
  initSchema,
  schemaToQueryString,
  schemaToExcelPreppedString,
  legoInputsToLegoSchema,
  legoInstanceInputsToInstanceSchema,
  setSchemaValuesToVariables,
  instanceElementToLegoInputRow,
  elementEmptyValue,
  instanceElementToLegoInstanceInputRow,
  legoInstanceInputToInstanceSchemaElement,
} from "./params";

/*

8888888b.           888                  88888888888                                  
888  "Y88b          888                      888                                      
888    888          888                      888                                      
888    888  8888b.  888888  8888b.           888  888  888 88888b.   .d88b.  .d8888b  
888    888     "88b 888        "88b          888  888  888 888 "88b d8P  Y8b 88K      
888    888 .d888888 888    .d888888          888  888  888 888  888 88888888 "Y8888b. 
888  .d88P 888  888 Y88b.  888  888          888  Y88b 888 888 d88P Y8b.          X88 
8888888P"  "Y888888  "Y888 "Y888888          888   "Y88888 88888P"   "Y8888   88888P' 
                                                       888 888                        
                                                  Y8b d88P 888                        
                                                   "Y88P"  888                        

*/

export type SkinnyKitDoll = {
  name: string;
  kitId: number;
  orgId: string;
  isCmd: boolean;
  directoryId: number | null;
  directoryName: string | null;
  cloudName: string | null;
  visibility: KitVisibility;
  ogKitId: number | null;
  description: string | null;
  hasAccess: boolean;
};
export type NOOutputColDoll = {
  path: string;
  noocId: number;
  pythonTypeStr: string | null;
  pyodbcInferredType: string | null;
};
export type SkinnyKitDollOC = {
  name: string;
  kitId: number;
  directoryId: number | null;
  directoryName: string | null;
  cloudName: string | null;
  outputColumns: NOOutputColDoll[];
};
export type SkinnyKitDollIC = {
  name: string;
  kitId: number;
  directoryId: number | null;
  directoryName: string | null;
  cloudName: string | null;
  legoInstanceInputs: ESkinnyKitInColGET_LegoInstanceInput[];
};
export type RecentKitDoll = {
  name: string;
  kitId: number;
  isCmd: boolean;
  source: string;
  uokId: string;
  lastViewed: string;
};

export type ForEachButtonDoll = EForEachButtonGET;

export type DecorationDoll = {
  decorationId: number;
  name: string;
  outputLegoInstanceId: number | null;
  outputKitId: number;
  resultSetZeroIdx: number | null;
  inputKitId: number | null;
  creatorUoId: string;
  colMaps: EDecorationGET_DecorationColMap[];
  inputKitName: string | null;
};
export type LegoDoll = {
  legoName: string; // coalesce(org_lego.override_name, lego.name)
  olId: string;
  legoDescription: string | null;
  directoryId: number | null;
  runOnStartup: boolean;
  runOnStartupValues: Record<string, any>;
  autocommit: boolean | null;
  runCredsId: number | null;
  syncCredsId: number | null;
  cloudId: string | null;
  cloudName: string | null;
  kitRunSchema: KitRunSchemaElement[];
  warningTag: string | null;
  runButtonText: string | null;
  runningMessage: string | null;
  legoInstanceId: number;
  /*
    "schema" (group of params) consists of "elements" (individual params)
    schema: [element, element, {objectPropertySchemas: [element, element, element]}]

    legoSchemaElement (aka lego.paramSchema)       // what we sync, stuff we can determine
    instanceSchemaElement                          // settings that the user applies on top (e.g. isHidden, defaultValue)
    kitRunSchemaElement                            // "live" values that we throw away (the actual parameter value, whether it's valid, etc)
  */
  order: number | null;
  collapsedView: boolean;
  isHidden: boolean;
  apiImageUrl: string | null;
  // Angus: we need to populate this
  kiliId: string | null;
  executable: string | null;
  executionEnv: string;
  decorations: DecorationDoll[];
  outputCols:
    | EDeepKit3GET_OL_NotOurOutputColumn[]
    | EDeepKit3GET_K_OL_NotOurOutputColumn[]
    | ENotOurOutputColumnGET[];
};

export type LegoDollUpdate = Partial<LegoDoll>;

export type NotebookProcessed = {
  kitId: number;
  cells: NotebookCellProcessed[];
  visibility: KitVisibility;
  name: string;
  directoryId: number | null;
  isCopycatKit: boolean | null;
  variableLinks:
    | EDeepKit3GET_VariableLink[]
    | EDeepKit3GET_K_VariableLink[]
    | null;
  dropdowns: Record<string, DropdownDoll>;
};
export type CmdProcessed = {
  kitId: number;
  legoDoll: LegoDoll;
  visibility: KitVisibility;
  name: string;
  directoryId: number | null;
  isCopycatKit: boolean | null;
  dropdowns: Record<string, DropdownDoll>;
};
export type NotebookCellProcessed = CmdProcessed & {
  order: number;
  kitInstanceId: number;
};

export type KitDollPlanOptions = {
  replaceParamQueryString?: boolean;
  setElementsToPropElements?: boolean;
  greenToastOnSuccess?: string;
  redToastOnFailure?: string;
};
export class KitDollPlan {
  kitDoll: CmdProcessed | NotebookProcessed | null;
  parallelRequests: ApiRequest[] | null;
  kitDollRequest: ApiRequest | null;
  options: KitDollPlanOptions;
  constructor({
    kitDoll = null,
    parallelRequests = null,
    kitDollRequest = null,
    options = {},
  }: {
    kitDoll?: CmdProcessed | NotebookProcessed | null;
    parallelRequests?: ApiRequest[] | null;
    kitDollRequest?: ApiRequest | null;
    options?: KitDollPlanOptions;
  } = {}) {
    this.kitDoll = kitDoll;
    this.parallelRequests = parallelRequests;
    this.options = options;
    this.kitDollRequest = kitDollRequest;
  }
  addOptions(o: KitDollPlanOptions) {
    this.options = omerge(this.options, o);
    return this;
  }
}

/*

8888888          d8b 888    d8b          888 d8b                   
  888            Y8P 888    Y8P          888 Y8P                   
  888                888                 888                       
  888   88888b.  888 888888 888  8888b.  888 888 88888888  .d88b.  
  888   888 "88b 888 888    888     "88b 888 888    d88P  d8P  Y8b 
  888   888  888 888 888    888 .d888888 888 888   d88P   88888888 
  888   888  888 888 Y88b.  888 888  888 888 888  d88P    Y8b.     
8888888 888  888 888  "Y888 888 "Y888888 888 888 88888888  "Y8888  
                                                                   
                                                                   
                                                                   

*/

function _initParamSchema3(
  legoInputs:
    | EDeepKit3GET_LII_LegoInput[]
    | EDeepKit3GET_K_LII_LegoInput[]
    | EDeepKit3GET_KI_K_LII_LegoInput[]
    | EDeepKit3GET_K_KI_K_LII_LegoInput[],
  legoInstanceInputs:
    | EDeepKit3GET_LegoInstanceInput[]
    | EDeepKit3GET_K_LegoInstanceInput[]
    | EDeepKit3GET_KI_K_LegoInstanceInput[]
    | EDeepKit3GET_K_KI_K_LegoInstanceInput[]
) {
  let legoInstanceInputSchema: InstanceSchemaElement[] = [];
  if (legoInputs.length > 0 && legoInstanceInputs.length === 0) {
    legoInstanceInputSchema = initSchema(legoInputsToLegoSchema(legoInputs), {
      from: "lego",
      to: "instance",
    });
  } else {
    legoInstanceInputSchema = legoInstanceInputsToInstanceSchema(
      legoInstanceInputs
    );
  }
  return initSchema(legoInstanceInputSchema, {
    from: "instance",
    to: "kitrun",
  });
}
function _initDecorationDoll(
  decoration:
    | EDecorationGET
    | EDeepKit3GET_Decoration
    | EDeepKit3GET_K_Decoration
): DecorationDoll {
  return {
    decorationId: decoration.decorationId,
    name: decoration.name,
    outputLegoInstanceId: decoration.outputLegoInstanceId,
    outputKitId: decoration.outputKitId,
    resultSetZeroIdx: decoration.resultSetZeroIdx,
    inputKitId: decoration.inputKitId,
    creatorUoId: decoration.creatorUoId,
    colMaps: decoration.colMaps,
    inputKitName: decoration.inputKit?.name ?? null,
  };
}
function _initDecorationDollList(
  decorations: EDecorationGET[]
): DecorationDoll[] {
  return decorations.map(_initDecorationDoll);
}
function _initLegoDoll3(
  deepKit:
    | EDeepKit3GET
    | EDeepKit3GET_Kit_2
    | EDeepKit3GET_KI_Kit
    | EDeepKit3GET_K_KI_Kit
): LegoDoll {
  const legoInstanceInputs = deepKit.legoInstanceInputs;
  const legoInputs = deepKit.legoInstanceInputs
    .filter((i: EDeepKit3GET_LegoInstanceInput) => i.legoInput !== null)
    .map((i: EDeepKit3GET_LegoInstanceInput) => i.legoInput);
  const kitRunSchema = _initParamSchema3(
    legoInputs,
    legoInstanceInputs
  ) as KitRunSchemaElement[];

  return {
    olId: deepKit.anchorOl.olId ?? "",
    order: 0,
    legoInstanceId: -1,
    kitRunSchema: kitRunSchema,
    legoName: pyCoalesce(deepKit.anchorOl.overrideName, deepKit.anchorOl.name),
    legoDescription: deepKit.anchorOl.description,
    //@ts-ignore
    directoryId: deepKit.directoryId,
    runOnStartup: deepKit.anchorOl.runOnStartup,
    runOnStartupValues: strToRunrams(deepKit.anchorOl.runOnStartupValues),
    autocommit: deepKit.anchorOl.autocommit,
    runCredsId: deepKit.anchorOl.runCredsId,
    syncCredsId: deepKit.anchorOl.syncCredsId,
    cloudId: deepKit.anchorOl.cloudId,
    cloudName: deepKit.anchorOl.name,
    warningTag: deepKit.anchorOl.warningTag,
    runButtonText: deepKit.anchorOl.runButtonText,
    runningMessage: deepKit.anchorOl.runningMessage,
    collapsedView: false,
    //@ts-ignore
    isHidden: false,
    apiImageUrl: deepKit.anchorOl.runCreds?.resource?.api?.imageUrl ?? null,
    //@ts-ignore
    kiliId: null,
    executable: deepKit.anchorOl.executable,
    executionEnv: deepKit.anchorOl.executionEnv as ExecutionEnv,
    decorations:
      "decorations" in deepKit
        ? _initDecorationDollList(deepKit.decorations)
        : [],
    outputCols: deepKit.anchorOl.noOutputCols,
  };
}

function _isEDeepKit3GETSingleLegoKit(
  deepKit: EDeepKit3GET | EDeepKit3GET_Kit_2
): boolean {
  return deepKit.anchorOl !== null && pyfalsey(deepKit.kitInstances);
}

function _initKitDoll3(
  deepKit: EDeepKit3GET
): CmdProcessed | NotebookProcessed {
  if (
    _isEDeepKit3GETSingleLegoKit(
      deepKit.ogKit !== null ? deepKit.ogKit : deepKit
    )
  ) {
    let dropdowns: Record<string, DropdownDoll> = {};
    if (deepKit.anchorOlId) {
      const dropdownList = deepKit.legoInstanceInputs
        .filter((lii: EDeepKit3GET_LegoInstanceInput) => lii.dropdown !== null)
        .map((lii: EDeepKit3GET_LegoInstanceInput) =>
          initDropdownDoll(lii.dropdown)
        );
      // lmap2oGen returns an object with string keys, even if dropdownId is a number
      dropdowns = lmap2oGen(
        dropdownList,
        (dd: DropdownDoll) => dd.dropdownId,
        (dd: DropdownDoll) => dd as DropdownDoll
      );
    }
    return enforceType<CmdProcessed>({
      kitId: deepKit.kitId,
      legoDoll: _initLegoDoll3(
        deepKit.ogKit !== null ? deepKit.ogKit : deepKit
      ),

      name: deepKit.name,
      visibility: deepKit.visibility as KitVisibility,
      directoryId: deepKit.directoryId,
      isCopycatKit: pytruthy(deepKit.ogKitId) ? true : false,
      dropdowns: dropdowns,
    });
  } else {
    console.log("NOT SINGLE LEGO KIT");
    const unorderedKitInstances = (deepKit.ogKit !== null
      ? deepKit.ogKit.kitInstances
      : deepKit.kitInstances
    ).map((ki: EDeepKit3GET_KitInstance | EDeepKit3GET_K_KitInstance) => {
      return enforceType<NotebookCellProcessed>({
        kitId: ki.childKit.kitId,
        legoDoll: _initLegoDoll3(ki.childKit),

        kitInstanceId: ki.kitInstanceId,
        order: ki.order,
        name: ki.childKit.name,
        visibility: ki.childKit.visibility as KitVisibility,
        directoryId: ki.childKit.directoryId,
        isCopycatKit: false,
        dropdowns: {},
      });
    });
    const dropdownList = (deepKit.ogKit !== null
      ? deepKit.ogKit.kitInstances
      : deepKit.kitInstances
    )
      .filter(
        (ki: EDeepKit3GET_KitInstance | EDeepKit3GET_K_KitInstance) =>
          ki.childKit.anchorOlId !== null
      )
      .map((ki: EDeepKit3GET_KitInstance | EDeepKit3GET_K_KitInstance) => {
        return (ki.childKit.legoInstanceInputs ?? [])
          .filter(
            (
              lii:
                | EDeepKit3GET_KI_K_LegoInstanceInput
                | EDeepKit3GET_K_KI_K_LegoInstanceInput
            ) => lii.dropdown !== null
          )
          .map(
            (
              lii:
                | EDeepKit3GET_KI_K_LegoInstanceInput
                | EDeepKit3GET_K_KI_K_LegoInstanceInput
            ) => initDropdownDoll(lii.dropdown)
          );
      })
      .flat();

    return enforceType<NotebookProcessed>({
      kitId: deepKit.kitId,
      cells: lsort(unorderedKitInstances, "order"),
      name: deepKit.name,
      visibility: deepKit.visibility as KitVisibility,
      directoryId: deepKit.directoryId,
      isCopycatKit: pytruthy(deepKit.ogKitId) ? true : false,
      variableLinks: deepKit.variableLinks,
      dropdowns: lmap2oGen(
        dropdownList,
        (dd: DropdownDoll) => dd.dropdownId,
        (dd: DropdownDoll) => dd as DropdownDoll
      ),
    });
  }
}
// const deep = {};
// _initKitDoll(oKeysToCamel(deep)); //=
function _initRecentKitDoll(r: EUserOrgKitRecentGET): RecentKitDoll {
  return {
    name: r.name,
    kitId: r.kitId ?? -1,
    isCmd: r.anchorOl !== null,
    source: r.source ?? "",
    uokId: r.uokId,
    lastViewed: r.lastViewed ?? "",
  };
}

function _initRecentKitDolls(list: EUserOrgKitRecentGET[]): RecentKitDoll[] {
  const listCopied = lcopy(list);
  const recentsFiltered = listCopied.filter((recent: any) => !recent.isHidden);
  return recentsFiltered.map(_initRecentKitDoll);
}

function _initSkinnyKit(
  skinny: ESkinnyKitGET,
  hasAccess = true
): SkinnyKitDoll {
  return {
    name: skinny.name,
    kitId: skinny.kitId,
    orgId: skinny.orgId,
    isCmd: skinny.anchorOl !== null, // TODO: demarcate this better somehow?
    directoryId: skinny.directory?.directoryId ?? null,
    directoryName: skinny.directory?.name ?? null,
    cloudName: skinny.anchorOl?.name ?? null,
    visibility: skinny.visibility as KitVisibility,
    ogKitId: skinny.ogKitId ?? null,
    description: skinny.anchorOl?.description ?? null,
    hasAccess: hasAccess,
  };
}

function _initPartialSkinnyKit(skinny: Partial<ESkinnyKitGET>): SkinnyKitDoll {
  return {
    name: skinny.name ?? "",
    kitId: skinny.kitId ?? -1,
    orgId: skinny.orgId ?? "",
    isCmd: skinny.anchorOl !== null,
    directoryId: skinny.directory?.directoryId ?? null,
    directoryName: skinny.directory?.name ?? null,
    cloudName: skinny.anchorOl?.name ?? null,
    visibility: skinny.visibility as KitVisibility,
    ogKitId: skinny.ogKitId ?? null,
    description: skinny.anchorOl?.description ?? null,
    hasAccess: true,
  };
}
// _initSkinnyKit({}); //=

function _initSkinnyKits(
  skinnyKits: ESkinnyKitGET[],
  hasAccess = true
): SkinnyKitDoll[] {
  return skinnyKits.map((skinny) => _initSkinnyKit(skinny, hasAccess));
}
function _initSkinnyKitOC(skinny: ESkinnyKitOutColGET): SkinnyKitDollOC {
  return {
    name: skinny.name,
    kitId: skinny.kitId,
    directoryId: skinny.directory?.directoryId ?? null,
    directoryName: skinny.directory?.name ?? null,
    cloudName: skinny.anchorOl?.name ?? null,
    outputColumns: skinny.anchorOl.noOutputCols.map(
      (oc: ESkinnyKitOutColGET_OL_NotOurOutputColumn) => ({
        noocId: oc.noOutColId,
        path: oc.path ?? "",
        pythonTypeStr: oc.pythonTypeStr,
        pyodbcInferredType: oc.pyodbcInferredType,
      })
    ),
  };
}
function _initSkinnyKitsOC(
  skinnyKits: ESkinnyKitOutColGET[]
): SkinnyKitDollOC[] {
  return skinnyKits.map(_initSkinnyKitOC);
}
function _initSkinnyKitIC(skinny: ESkinnyKitInColGET): SkinnyKitDollIC {
  return {
    name: skinny.name,
    kitId: skinny.kitId,
    directoryId: skinny.directory?.directoryId ?? null,
    directoryName: skinny.directory?.name ?? null,
    cloudName: skinny.anchorOl?.name ?? null,
    legoInstanceInputs: skinny.legoInstanceInputs,
  };
}
function _initSkinnyKitsIC(
  skinnyKits: ESkinnyKitInColGET[]
): SkinnyKitDollIC[] {
  return skinnyKits.map(_initSkinnyKitIC);
}
/*




8888888b.          888    888      
888   Y88b         888    888      
888    888         888    888      
888   d88P 8888b.  888888 88888b.  
8888888P"     "88b 888    888 "88b 
888       .d888888 888    888  888 
888       888  888 Y88b.  888  888 
888       "Y888888  "Y888 888  888 
                                   
                                   
                                   

*/

function _isCmd(kd: CmdProcessed | NotebookProcessed) {
  return "legoDoll" in kd;
}

/*

888       888         d8b 888                     
888   o   888         Y8P 888                     
888  d8b  888             888                     
888 d888b 888 888d888 888 888888 .d88b.  .d8888b  
888d88888b888 888P"   888 888   d8P  Y8b 88K      
88888P Y88888 888     888 888   88888888 "Y8888b. 
8888P   Y8888 888     888 Y88b. Y8b.          X88 
888P     Y888 888     888  "Y888 "Y8888   88888P' 
                                                  
                                                  
                                                  
*/

function _setCellLegoDoll(
  kd: NotebookProcessed,
  kitInstanceId: number | null,
  update: LegoDollUpdate
): NotebookProcessed {
  const c = ocopy(kd);
  const ref = lfind(
    c.cells,
    (cell) => cell.kitInstanceId === kitInstanceId,
    null
  )?.legoDoll;
  if (!ref) {
    return c;
  }
  for (const key in update) {
    //@ts-ignore
    ref[key] = update[key];
  }
  return c;
}

/*

8888888b.                                                     888                  888       888                                                             
888   Y88b                                                    888                  888   o   888                                                             
888    888                                                    888                  888  d8b  888                                                             
888   d88P 8888b.  888d888 8888b.  88888b.d88b.  .d8888b      888888 .d8888b       888 d888b 888 888d888 8888b.  88888b.  88888b.   .d88b.  888d888 .d8888b  
8888888P"     "88b 888P"      "88b 888 "888 "88b 88K          888    88K           888d88888b888 888P"      "88b 888 "88b 888 "88b d8P  Y8b 888P"   88K      
888       .d888888 888    .d888888 888  888  888 "Y8888b.     888    "Y8888b.      88888P Y88888 888    .d888888 888  888 888  888 88888888 888     "Y8888b. 
888       888  888 888    888  888 888  888  888      X88 d8b Y88b.       X88      8888P   Y8888 888    888  888 888 d88P 888 d88P Y8b.     888          X88 
888       "Y888888 888    "Y888888 888  888  888  88888P' Y8P  "Y888  88888P'      888P     Y888 888    "Y888888 88888P"  88888P"   "Y8888  888      88888P' 
                                                                                                                 888      888                                
                                                                                                                 888      888                                
                                                                                                                 888      888                                

8888888b.                                                     888                  888       888                                                             
888   Y88b                                                    888                  888   o   888                                                             
888    888                                                    888                  888  d8b  888                                                             
888   d88P 8888b.  888d888 8888b.  88888b.d88b.  .d8888b      888888 .d8888b       888 d888b 888 888d888 8888b.  88888b.  88888b.   .d88b.  888d888 .d8888b  
8888888P"     "88b 888P"      "88b 888 "888 "88b 88K          888    88K           888d88888b888 888P"      "88b 888 "88b 888 "88b d8P  Y8b 888P"   88K      
888       .d888888 888    .d888888 888  888  888 "Y8888b.     888    "Y8888b.      88888P Y88888 888    .d888888 888  888 888  888 88888888 888     "Y8888b. 
888       888  888 888    888  888 888  888  888      X88 d8b Y88b.       X88      8888P   Y8888 888    888  888 888 d88P 888 d88P Y8b.     888          X88 
888       "Y888888 888    "Y888888 888  888  888  88888P' Y8P  "Y888  88888P'      888P     Y888 888    "Y888888 88888P"  88888P"   "Y8888  888      88888P' 
                                                                                                                 888      888                                
                                                                                                                 888      888                                
                                                                                                                 888      888                                

8888888b.                                                     888                  888       888                                                             
888   Y88b                                                    888                  888   o   888                                                             
888    888                                                    888                  888  d8b  888                                                             
888   d88P 8888b.  888d888 8888b.  88888b.d88b.  .d8888b      888888 .d8888b       888 d888b 888 888d888 8888b.  88888b.  88888b.   .d88b.  888d888 .d8888b  
8888888P"     "88b 888P"      "88b 888 "888 "88b 88K          888    88K           888d88888b888 888P"      "88b 888 "88b 888 "88b d8P  Y8b 888P"   88K      
888       .d888888 888    .d888888 888  888  888 "Y8888b.     888    "Y8888b.      88888P Y88888 888    .d888888 888  888 888  888 88888888 888     "Y8888b. 
888       888  888 888    888  888 888  888  888      X88 d8b Y88b.       X88      8888P   Y8888 888    888  888 888 d88P 888 d88P Y8b.     888          X88 
888       "Y888888 888    "Y888888 888  888  888  88888P' Y8P  "Y888  88888P'      888P     Y888 888    "Y888888 88888P"  88888P"   "Y8888  888      88888P' 
                                                                                                                 888      888                                
                                                                                                                 888      888                                
                                                                                                                 888      888                                

*/

/*


888     888 8888888b.  888           8888888b.                                                 
888     888 888   Y88b 888           888   Y88b                                                
888     888 888    888 888           888    888                                                
888     888 888   d88P 888           888   d88P 8888b.  888d888 8888b.  88888b.d88b.  .d8888b  
888     888 8888888P"  888           8888888P"     "88b 888P"      "88b 888 "888 "88b 88K      
888     888 888 T88b   888           888       .d888888 888    .d888888 888  888  888 "Y8888b. 
Y88b. .d88P 888  T88b  888           888       888  888 888    888  888 888  888  888      X88 
 "Y88888P"  888   T88b 88888888      888       "Y888888 888    "Y888888 888  888  888  88888P' 
                                                                                               
                                                                                               
                                                                                               
*/
const sortKitBuilderQueryParams = (
  [k1, v1]: [string, unknown],
  [k2, v2]: [string, unknown]
) => {
  if (k1 === "id") {
    return -1;
  } else if (k2 === "id") {
    return 1;
  } else if (k1 === "runId") {
    return -1;
  } else if (k2 === "runId") {
    return 1;
  } else if (k1 === "params") {
    return 1;
  } else if (k2 === "params") {
    return -1;
  } else {
    return 0;
  }
};
function _toExcelFormula(
  kd: CmdProcessed | NotebookProcessed,
  origin: string,
  path: string,
  queryObj: any,
  hyperlinkText: string
) {
  // Not making a copy here since this method is read only and needs to be fast
  let allCmds: [string, LegoDoll][] = [];
  if (_isCmd(kd)) {
    allCmds = [["", (kd as CmdProcessed).legoDoll]];
  } else {
    allCmds = (kd as NotebookProcessed).cells.map((cell) => [
      cell.kitInstanceId.toString(),
      cell.legoDoll,
    ]);
  }
  let paramQs = allCmds
    .map(([kitInstanceIdStr, ld]) =>
      schemaToExcelPreppedString(kitInstanceIdStr, ld.kitRunSchema)
    )
    .filter((qs) => qs.length !== 0)
    .join(",");
  paramQs = paramQs.replace(/%%%FLANKBLANK%%%,/g, '"&A2&",');
  paramQs = paramQs.replace(/%%%FLANKBLANK%%%$/, '"&A2&"'); // params at end
  let queryString = oitems(
    omerge(queryObj, paramQs.length > 0 ? { params: paramQs } : {})
  )
    // sort array where 'id' is first, 'runId' is second and 'params' are last
    .sort(sortKitBuilderQueryParams)
    .map(([k, v]) => `${k}=${v}`)
    .join("&");
  queryString = queryString.length > 0 ? `?${queryString}` : "";
  return `=HYPERLINK("${origin}${path}${queryString}", "${hyperlinkText}")`;
}

function _toQueryString(kd: CmdProcessed | NotebookProcessed) {
  // Not making a copy here since this method is read only and needs to be fast
  let allCmds: [string, LegoDoll][] = [];
  if (_isCmd(kd)) {
    allCmds = [["", (kd as CmdProcessed).legoDoll]];
  } else {
    allCmds = (kd as NotebookProcessed).cells.map((cell) => [
      cell.kitInstanceId.toString(),
      cell.legoDoll,
    ]);
  }
  return allCmds
    .map(([kitInstanceIdStr, ld]) =>
      schemaToQueryString(kitInstanceIdStr, ld.kitRunSchema, {
        variableLinks: _isCmd(kd)
          ? []
          : (kd as NotebookProcessed).variableLinks ?? [],
      })
    )
    .filter((qs) => qs.length !== 0)
    .join(",");
}
function _extractKitInstanceIdStrFromPath(fullPath: string): string {
  const pathParts = pathSplit(fullPath);
  if (pathParts.length > 1 && /^\d+$/.test(pathParts[0])) {
    return pathParts[0];
  }
  return "";
}
function _extractParamPath(fullPath: string) {
  const pathParts = pathSplit(fullPath);
  if (pathParts.length > 1 && /^\d+$/.test(pathParts[0])) {
    return pathsJoin(pathRest(fullPath));
  }
  return fullPath;
}

// _extractKitInstanceIdStrFromPath("456.this.is.nested"); //=
// _extractKitInstanceIdStrFromPath("blah.this.is.nested"); //=
// _extractParamPath("blah.this.is.nested"); //=
// _extractParamPath("456.this.is.nested"); //=

function _bindUrlParams(
  kd: CmdProcessed | NotebookProcessed,
  urlParams: Record<string, string> | null,
  depth = 0
) {
  if (urlParams === null) {
    return kd;
  }
  const lookupByInstance = ovaluemap(
    lgroupBy(
      oitems(urlParams).map(([k, v]: [string, any]) => [
        _extractKitInstanceIdStrFromPath(k),
        _extractParamPath(k),
        v,
      ]),
      ([i, k, v]) => i
    ),
    (v: unknown) =>
      lot2o((v as [string, string, string][]).map(([i, k, v]) => [k, v]))
  );
  let c;
  if (depth == 0) {
    c = ocopy(kd);
  } else {
    c = kd;
  }
  let allCmds: [string, LegoDoll][] = [];
  if (_isCmd(c)) {
    allCmds = [["", (c as CmdProcessed).legoDoll]];
  } else {
    allCmds = (c as NotebookProcessed).cells.map((cell) => [
      cell.kitInstanceId.toString(),
      cell.legoDoll,
    ]);
  }
  for (const [kitInstanceIdStr, ref] of allCmds) {
    ref.kitRunSchema = bindFlatParamsToSchema(
      ref.kitRunSchema,
      oget(lookupByInstance, kitInstanceIdStr)
    );
  }
  return c;
}

// const path =
//   "/flank-interns-1/builder?id=5221&runGroupId=1106&params=root.li_5000.job_title%3A%3A%3ARecruiter,root.li_5000.location%3A%3A%3A%22United%20States%22,root.li_5000.post_date%3A%3A%3A%22Past%20Month%22,root.li_5000.work_type%5B0%5D%3A%3A%3Aon-site,root.li_5000.job_type%5B0%5D%3A%3A%3Afull-time,root.li_5000.company_size%5B0%5D%3A%3A%3A%2211-50%20employees%22,root.li_5000.company_size%5B1%5D%3A%3A%3A%2251-200%20employees%22,root.li_5000.company_size%5B2%5D%3A%3A%3A%22501-1000%20employees%22,root.li_5000.company_size%5B3%5D%3A%3A%3A%225001-10000%20employees%22,root.li_5000.include_industries%5B0%5D%3A%3A%3AEducation,root.li_5000.exclude_staffing_agencies%3A%3A%3Atrue,root.li_5000.remove_duplicate_companies%3A%3A%3Atrue,root.li_5000.hiring_manager_job_title%3A%3A%3A%22her,her,her%22,root.li_5000.pocs_per_company%3A%3A%3A3,root.li_5000.limit_contact_per_search%3A%3A%3A20";
// const path =
//   "/flank-interns-1/builder?id=5221&runGroupId=1106&params=root.li_5000.job_title%3A%3A%3ARecruiter,root.li_5000.location%3A%3A%3AUnited%20States,root.li_5000.post_date%3A%3A%3APast%20Month,root.li_5000.work_type%5B0%5D%3A%3A%3Aon-site,root.li_5000.job_type%5B0%5D%3A%3A%3Afull-time,root.li_5000.company_size%5B0%5D%3A%3A%3A11-50%20employees,root.li_5000.company_size%5B1%5D%3A%3A%3A51-200%20employees,root.li_5000.company_size%5B2%5D%3A%3A%3A501-1000%20employees,root.li_5000.company_size%5B3%5D%3A%3A%3A5001-10000%20employees,root.li_5000.include_industries%5B0%5D%3A%3A%3AEducation,root.li_5000.exclude_staffing_agencies%3A%3A%3Atrue,root.li_5000.remove_duplicate_companies%3A%3A%3Atrue,root.li_5000.hiring_manager_job_title%3A%3A%3Aher,null%3A%3A%3Anull,root.li_5000.pocs_per_company%3A%3A%3A3,root.li_5000.limit_contact_per_search%3A%3A%3A20";
// const path =
//   "/flank-demos-1/builder?id=12634&runGroupId=4285&params=root.li_12382.job_title%3A%3A%3Ahello,root.li_12382.exclude_staffing_agencies%3A%3A%3Afalse,root.li_12382.use_flank_hm_identifier%3A%3A%3Afalse";
// const qps = pathToQueryParams(path); //=
// import pe from "./paramExamples";
// _bindUrlParams(pe.kitDoll2, qps.params); //=
// _bindUrlParams(
//   {
//     kitInstanceId: "root",
//     legoDolls: [
//       { legoInstanceId: 5, kitRunSchema: [{ key: "hi", value: "" }] },
//       { legoInstanceId: 7, kitRunSchema: [{ key: "hi", value: "" }] },
//     ],
//   },
//   { "root.li_5.hi": "1" }
// ).legoDolls[0]; //=
// https://www.flank.cloud/flank-demos-1/builder?id=9352&runGroupId=2695&params=root.ki_281.li_9203.What%20is%20it%3F%3A%3A%3A%22panda%20in%20a%20ball%20pit%22,root.ki_283.li_9205.Emotions%3A%3A%3A%22negative%20mood,%20low%20energy%22,root.ki_285.li_9207.Size%20and%20structure%3A%3A%3A%22big%20and%20structured%22,root.ki_287.li_9209.Looks%20and%20vibes%3A%3A%3A%22gothic,%20fantasy%22,root.ki_289.li_9211.Camera%20proximity%3A%3A%3A%22long%20shot%22,root.ki_291.li_9213.Camera%20position%3A%3A%3A%22overhead%20view%22,root.ki_293.li_9215.Camera%20lens%3A%3A%3A%22wide%20angle%20lens,%2015mm%22,root.ki_295.li_9217.Outdoor%20lighting%3A%3A%3Aovercast,root.ki_297.li_9219.Indoor%20lighting%3A%3A%3A%22high-key%20lighting%22,root.ki_301.li_9223.Film%20style%3A%3A%3Apolaroid,root.ki_303.li_9225.Photo%20genre%3A%3A%3A%22candid%20street%20portrait%22,root.ki_280.li_9025.what_is_it%3A%3A%3A%22panda%20in%20a%20ball%20pit%22,root.ki_280.li_9025.emotion%3A%3A%3A%22negative%20mood,%20low%20energy%22,root.ki_280.li_9025.sizey_structurey_words%3A%3A%3A%22big%20and%20structured%22,root.ki_280.li_9025.looks_and_vibes%3A%3A%3A%22gothic,%20fantasy%22,root.ki_280.li_9025.camera_proximity%3A%3A%3A%22long%20shot%22,root.ki_280.li_9025.camera_position%3A%3A%3A%22overhead%20view%22,root.ki_280.li_9025.camera_lenses%3A%3A%3A%22wide%20angle%20lens,%2015mm%22,root.ki_280.li_9025.outdoor_lighting%3A%3A%3Aovercast,root.ki_280.li_9025.indoor_lighting%3A%3A%3A%22high-key%20lighting%22,root.ki_280.li_9025.film_styles%3A%3A%3Apolaroid,root.ki_280.li_9025.photo_genre%3A%3A%3A%22candid%20street%20portrait%22,root.ki_280.li_9025.portrait_photographer%3A%3A%3A,root.ki_280.li_9025.illustration_style%3A%3A%3A,root.ki_280.li_9025.art_history_style%3A%3A%3A,root.ki_280.li_9025.statue_style%3A%3A%3A,root.ki_280.li_9025.paper_and_textiles%3A%3A%3A,root.ki_280.li_9025.ceramics_and_glass%3A%3A%3A
// _bindUrlParams(
//   {
//     kitInstanceId: "root",
//     cells: [
//       {
//         kitInstanceId: 456,
//         legoDolls: [
//           { legoInstanceId: 5, kitRunSchema: [{ key: "hi", value: "" }] },
//           { legoInstanceId: 7, kitRunSchema: [{ key: "hi", value: "" }] },
//         ],
//       },
//     ],
//   },
//   { "root.ki_456.li_5.hi": "1" }
// ).cells[0].legoDolls[0]; //=
// _bindUrlParams2(
//   {
//     kitInstanceId: "root",
//     cells: [
//       {
//         kitInstanceId: 456,
//         legoDolls: [
//           {
//             legoInstanceId: 5,
//             kitRunSchema: [
//               {
//                 key: "hi",
//                 value: "",
//                 jsonType: "object",
//                 objectPropertySchemas: [{ key: "there", value: "" }],
//               },
//             ],
//           },
//         ],
//       },
//     ],
//   },
//   { "root.ki_456.li_5.hi.there": "1" }
// ).cells[0].legoDolls[0].kitRunSchema[0].objectPropertySchemas; //=
// _bindUrlParams(
//   {
//     kitInstanceId: "root",
//     cells: [
//       {
//         kitInstanceId: 456,
//         legoDolls: [
//           {
//             legoInstanceId: 5,
//             kitRunSchema: [
//               {
//                 key: "hi",
//                 jsonType: "array",
//                 listElements: [{ value: "" }],
//               },
//             ],
//           },
//         ],
//       },
//     ],
//   },
//   { "root.ki_456.li_5.hi[0]": "1" }
// ).cells[0].legoDolls[0].kitRunSchema[0].listElements[0]; //=

type TuplePair = [any, any];

function _flattenOnceNestedTuples(
  list: Array<TuplePair | TuplePair[]>
): TuplePair[] {
  const flattened: TuplePair[] = [];

  for (const item of list) {
    if (isArray(item[0])) {
      flattened.push(...(item as TuplePair[]));
    } else {
      flattened.push(item as TuplePair);
    }
  }

  return flattened;
}

// const data = [
//   ["k1", "v1"],
//   ["k2", "v2"],
//   [
//     ["k3", "v3"],
//     ["k4", "v4"],
//   ],
// ];
// flattenOnceNestedTuples(data); //=

function _addressAmbiguousParams(
  kd: CmdProcessed | NotebookProcessed,
  params: Record<string, string> | null
): Record<string, string> | null {
  if (params === null) return params;
  const list = oitems(params).map(([k, v]) => {
    if (/root\.li_\d+\..+/.test(k)) {
      // backwards compatibility
      return [pathRest(pathRest(k)), v];
    } else if (/root\.ki_\d+\.li_\d+\..+/.test(k)) {
      // backwards compatibility
      const kiPart = pathFirst(pathRest(k)).split("_")[1];
      return [pathJoin(kiPart, pathRest(pathRest(pathRest(k)))), v];
    } else if (!_isCmd(kd) && /\d+\.{1,}.*/.test(k)) {
      return [k, v];
    } else if (!_isCmd(kd)) {
      const matchingElements = (kd as NotebookProcessed).cells
        .map((cell: NotebookCellProcessed) =>
          cell.legoDoll.kitRunSchema.map((kre: KitRunSchemaElement) => [
            cell.kitInstanceId,
            kre,
          ])
        )
        .flat()
        // @ts-ignore
        .filter((pair): pair is [number, KitRunSchemaElement] => {
          const [kiid, kre] = pair as [number, KitRunSchemaElement];
          return kre.key === k;
        });
      if (matchingElements.length > 0) {
        return matchingElements.map(
          ([kiid, kre]: [number, KitRunSchemaElement]) => [
            pathJoin(kiid, kre.key),
            v,
          ]
        );
      } else {
        return [k, v];
      }
    } else {
      return [k, v];
    }
  }) as Array<TuplePair | TuplePair[]>;
  return lot2o(_flattenOnceNestedTuples(list)) as Record<string, string>;
}
// const p1 =
//   "/flank-interns-1/builder?id=2994&runGroupId=1045&params=root.li_2976.%40userId%3A%3A%3A2";
// const p =
//   "/flank-interns-1/builder?id=2994&runGroupId=1045&params=%40userIdd%3A%3A%3A2";
// pathToQueryParams(p); //=
// const sch = [
//   {
//     key: "@userId",
//     typeSystem: "mssql",
//     typeId: "int",
//     jsonType: "number",
//     component: "b-input",
//     inputType: "number",
//     objectPropertySchemas: null,
//     listElementSchema: null,
//     defaultValue: null,
//     defaultAmbiguousInput: null,
//     useDefaultValue: false,
//     lockDefaultValue: false,
//     hidden: false,
//     note: "",
//     manuallyAdded: false,
//     uuid: "2908e306-5d01-40c5-9e54-48faeba9df29",
//     listElements: null,
//     value: 2,
//     isValid: true,
//   },
// ];
// const kd = {
//   kitId: 2994,
//   cells: null,
//   legoDolls: [
//     {
//       order: 0,
//       legoInstanceId: 4979,
//       kitRunSchema: [
//         {
//           key: "@userId",
//           typeSystem: "mssql",
//           typeId: "int",
//           constraints: {
//             multipleOf: null,
//             maximum: "2147483647",
//             exclusiveMaximum: null,
//             minimum: "-2147483648",
//             exclusiveMinimum: null,
//             maxLength: 4,
//             minLength: null,
//             pattern: null,
//             maxItems: null,
//             minItems: null,
//             uniqueItems: null,
//             maxProperties: null,
//             minProperties: null,
//             required: null,
//             readOnly: null,
//             writeOnly: null,
//             nullable: null,
//             enum: null,
//             validationMessage: null,
//             step: "1",
//           },
//           jsonType: "number",
//           component: "b-input",
//           inputType: "number",
//           objectPropertySchemas: null,
//           listElementSchema: null,
//           defaultValue: null,
//           defaultAmbiguousInput: null,
//           useDefaultValue: false,
//           lockDefaultValue: false,
//           hidden: false,
//           note: "",
//           manuallyAdded: false,
//           uuid: "58f16e88-3b6b-4c3e-ae4d-4a2f4606c8ec",
//           listElements: null,
//           value: "2",
//           isValid: true,
//         },
//       ],

//       legoName: "get_users",
//       legoDescription: null,
//       directoryId: null,
//       runOnStartup: null,
//       runOnStartupValues: {},
//       runCredsId: 191,
//       syncCredsId: 191,
//       cloudId:
//         "db::mssql::fomf-sandbox-ssdb.database.windows.net::fomf-ss-sandbox-db::dbo::procedure::get_users",
//       cloudName: "get_users",
//       warningTag: null,
//       runButtonText: null,
//       collapsedView: true,
//       isHidden: false,
//       apiImageUrl: null,
//       kiliId: null,
//       executable: null,
//       executionEnv: "nol",
//     },
//     {
//       order: 1,
//       legoInstanceId: 2976,
//       kitRunSchema: [
//         {
//           key: "@userId",
//           typeSystem: "mssql",
//           typeId: "int",
//           constraints: {
//             multipleOf: null,
//             maximum: "2147483647",
//             exclusiveMaximum: null,
//             minimum: "-2147483648",
//             exclusiveMinimum: null,
//             maxLength: 4,
//             minLength: null,
//             pattern: null,
//             maxItems: null,
//             minItems: null,
//             uniqueItems: null,
//             maxProperties: null,
//             minProperties: null,
//             required: null,
//             readOnly: null,
//             writeOnly: null,
//             nullable: null,
//             enum: null,
//             validationMessage: null,
//             step: "1",
//           },
//           jsonType: "number",
//           component: "b-input",
//           inputType: "number",
//           objectPropertySchemas: null,
//           listElementSchema: null,
//           defaultValue: null,
//           defaultAmbiguousInput: null,
//           useDefaultValue: false,
//           lockDefaultValue: false,
//           hidden: false,
//           note: "",
//           manuallyAdded: false,
//           uuid: "58f16e88-3b6b-4c3e-ae4d-4a2f4606c8ec",
//           listElements: null,
//           value: "2",
//           isValid: true,
//         },
//       ],
//       legoName: "getUserAge",
//       legoDescription: null,
//       directoryId: null,
//       runOnStartup: null,
//       runOnStartupValues: {},
//       runCredsId: 191,
//       syncCredsId: 191,
//       cloudId:
//         "db::mssql::fomf-sandbox-ssdb.database.windows.net::fomf-ss-sandbox-db::dbo::procedure::getUserAge",
//       cloudName: "getUserAge",
//       warningTag: null,
//       runButtonText: null,
//       collapsedView: false,
//       isHidden: false,
//       apiImageUrl: null,
//       kiliId: null,
//       executable: null,
//       executionEnv: "nol",
//     },
//   ],
//   kitInstanceId: "root",
//   order: 0,
//   name: "getUserAge",
//   visibility: "org",
//   directoryId: null,
// };

// _addressAmbiguousParams(kd, pathToQueryParams(p).params); //=
/*


8888888b.            .d888                  888 888         888     888         888                            
888  "Y88b          d88P"                   888 888         888     888         888                            
888    888          888                     888 888         888     888         888                            
888    888  .d88b.  888888 8888b.  888  888 888 888888      Y88b   d88P 8888b.  888 888  888  .d88b.  .d8888b  
888    888 d8P  Y8b 888       "88b 888  888 888 888          Y88b d88P     "88b 888 888  888 d8P  Y8b 88K      
888    888 88888888 888   .d888888 888  888 888 888           Y88o88P  .d888888 888 888  888 88888888 "Y8888b. 
888  .d88P Y8b.     888   888  888 Y88b 888 888 Y88b.          Y888P   888  888 888 Y88b 888 Y8b.          X88 
8888888P"   "Y8888  888   "Y888888  "Y88888 888  "Y888          Y8P    "Y888888 888  "Y88888  "Y8888   88888P' 
                                                                                                               
                                                                                                               
                                                                                                               
*/
function _setDefaultValues(
  kd: CmdProcessed | NotebookProcessed
): CmdProcessed | NotebookProcessed {
  const c = ocopy(kd);
  if (_isCmd(c)) {
    (c as CmdProcessed).legoDoll.kitRunSchema = setSchemaValuesToDefaults(
      (c as CmdProcessed).legoDoll.kitRunSchema
    );
  } else {
    (c as NotebookProcessed).cells.forEach(
      (cell) =>
        (cell.legoDoll.kitRunSchema = setSchemaValuesToDefaults(
          cell.legoDoll.kitRunSchema
        ))
    );
  }
  return c;
}
function _setEnvVariableValues(
  kd: CmdProcessed | NotebookProcessed,
  variables: { [key: string]: any }
): CmdProcessed | NotebookProcessed {
  const c = ocopy(kd);
  if (_isCmd(c)) {
    (c as CmdProcessed).legoDoll.kitRunSchema = setSchemaValuesToVariables(
      (c as CmdProcessed).legoDoll.kitRunSchema,
      variables
    );
  } else {
    (c as NotebookProcessed).cells?.forEach(
      (cell) =>
        (cell.legoDoll.kitRunSchema = setSchemaValuesToVariables(
          cell.legoDoll.kitRunSchema,
          variables
        ))
    );
  }
  return c;
}

/*



8888888b.  888                        8888888b.  888                        8888888b.  888                   
888   Y88b 888                        888   Y88b 888                        888   Y88b 888                   
888    888 888                        888    888 888                        888    888 888                   
888   d88P 888  8888b.  88888b.       888   d88P 888  8888b.  88888b.       888   d88P 888  8888b.  88888b.  
8888888P"  888     "88b 888 "88b      8888888P"  888     "88b 888 "88b      8888888P"  888     "88b 888 "88b 
888        888 .d888888 888  888      888        888 .d888888 888  888      888        888 .d888888 888  888 
888        888 888  888 888  888      888        888 888  888 888  888      888        888 888  888 888  888 
888        888 "Y888888 888  888      888        888 "Y888888 888  888      888        888 "Y888888 888  888 
                                                                                                             
                                                                                                             
                                                                                                             
8888888b.  888                        8888888b.  888                        8888888b.  888                   
888   Y88b 888                        888   Y88b 888                        888   Y88b 888                   
888    888 888                        888    888 888                        888    888 888                   
888   d88P 888  8888b.  88888b.       888   d88P 888  8888b.  88888b.       888   d88P 888  8888b.  88888b.  
8888888P"  888     "88b 888 "88b      8888888P"  888     "88b 888 "88b      8888888P"  888     "88b 888 "88b 
888        888 .d888888 888  888      888        888 .d888888 888  888      888        888 .d888888 888  888 
888        888 888  888 888  888      888        888 888  888 888  888      888        888 888  888 888  888 
888        888 "Y888888 888  888      888        888 "Y888888 888  888      888        888 "Y888888 888  888 
                                                                                                             
                                                                                                             
                                                                                                             
8888888b.  888                        8888888b.  888                        8888888b.  888                   
888   Y88b 888                        888   Y88b 888                        888   Y88b 888                   
888    888 888                        888    888 888                        888    888 888                   
888   d88P 888  8888b.  88888b.       888   d88P 888  8888b.  88888b.       888   d88P 888  8888b.  88888b.  
8888888P"  888     "88b 888 "88b      8888888P"  888     "88b 888 "88b      8888888P"  888     "88b 888 "88b 
888        888 .d888888 888  888      888        888 .d888888 888  888      888        888 .d888888 888  888 
888        888 888  888 888  888      888        888 888  888 888  888      888        888 888  888 888  888 
888        888 "Y888888 888  888      888        888 "Y888888 888  888      888        888 "Y888888 888  888 
                                                                                                             
                                                                                                             
                                                                                                             
8888888b.  888                        8888888b.  888                        8888888b.  888                   
888   Y88b 888                        888   Y88b 888                        888   Y88b 888                   
888    888 888                        888    888 888                        888    888 888                   
888   d88P 888  8888b.  88888b.       888   d88P 888  8888b.  88888b.       888   d88P 888  8888b.  88888b.  
8888888P"  888     "88b 888 "88b      8888888P"  888     "88b 888 "88b      8888888P"  888     "88b 888 "88b 
888        888 .d888888 888  888      888        888 .d888888 888  888      888        888 .d888888 888  888 
888        888 888  888 888  888      888        888 888  888 888  888      888        888 888  888 888  888 
888        888 "Y888888 888  888      888        888 "Y888888 888  888      888        888 "Y888888 888  888 
                                                                                                             

                                                                       
                                                                       
                                                                       

*/

/*


 .d8888b.                             
d88P  Y88b                            
Y88b.                                 
 "Y888b.   888  888 88888b.   .d8888b 
    "Y88b. 888  888 888 "88b d88P"    
      "888 888  888 888  888 888      
Y88b  d88P Y88b 888 888  888 Y88b.    
 "Y8888P"   "Y88888 888  888  "Y8888P 
                888                   
           Y8b d88P                   
            "Y88P"                    

            */

function _planToSync(
  kd: CmdProcessed | NotebookProcessed,
  kitInstanceId: number | null
): KitDollPlan {
  const legoDoll = _isCmd(kd)
    ? (kd as CmdProcessed).legoDoll
    : lfind(
        (kd as NotebookProcessed).cells,
        (c) => c.kitInstanceId === kitInstanceId,
        null
      )?.legoDoll ?? null;
  if (legoDoll === null) {
    return new KitDollPlan({ kitDoll: kd });
  }
  return new KitDollPlan({
    kitDollRequest: {
      method: HttpMethod.POST,
      path: "syncs-2",
      body: { olId: legoDoll.olId, credsId: legoDoll.syncCredsId },
      options: { orgPath: true },
      callback: (syncResp: SyncWrapper) => {
        if (syncResp.stage1?.error || syncResp.stage2?.error) {
          throw Error(
            pyCoalesce(syncResp.stage1?.error, syncResp.stage2?.error)
          );
        }
        return {
          method: HttpMethod.GET,
          path: `command-templates/${legoDoll.olId}`,
          options: {
            orgPath: true,
            query: { filter: ["is_deleted:False"] },
          },
          callback: (legoResp: ELegoGET) => _updateLegoAfterSync(kd, legoResp),
        };
      },
    },
  });
}
function _updateLegoAfterSync(
  kd: CmdProcessed | NotebookProcessed,
  lego: ELegoGET
) {
  const c = ocopy(kd);
  let allCmds: CmdProcessed[] | NotebookProcessed = [];
  if (_isCmd(c)) {
    allCmds = [c as CmdProcessed];
  } else {
    allCmds = (c as NotebookProcessed).cells ?? [];
  }
  (allCmds ?? []).forEach((cmd) => {
    cmd.legoDoll.kitRunSchema = injectLegoSchemaIntoKitRunSchema(
      cmd.legoDoll.kitRunSchema,
      legoInputsToLegoSchema(lego.legoInputs) // AM: HERE
    );
    cmd.legoDoll.legoName = lego.name ?? "";
    cmd.legoDoll.legoDescription = lego.description;
  });

  return {
    method: HttpMethod.GET,
    path: `deep-kits-3/${c.kitId}`,
    options: {
      orgPath: true,
      query: { filter: ["is_deleted:False"] },
    },
    callback: (getResp: EDeepKit3GET) => {
      return {
        kitDoll: _initKitDoll3(getResp),
      };
    },
  };
}
// _updateLegoAfterSync(
//   {
//     kitInstanceId: "root",
//     legoDolls: [
//       {
//         kitRunSchema: [{ key: "@a", typeId: "int", value: "123" }],
//       },
//     ],
//   },
//   oKeysToCamel({
//     org_id: "sandbox-119",
//     param_schema:
//       '[{"key": "@a", "type_system": "mssql", "type_id": "int", "json_type": "number", "component": "b-input", "input_type": "number", "constraints": {"multiple_of": null, "maximum": "2147483647", "exclusive_maximum": null, "minimum": "-2147483648", "exclusive_minimum": null, "max_length": 4, "min_length": null, "pattern": null, "max_items": null, "min_items": null, "unique_items": null, "max_properties": null, "min_properties": null, "required": null, "read_only": null, "write_only": null, "nullable": null, "enum": null, "validation_message": null, "step": "1"}, "object_property_schemas": null, "list_element_schema": null}, {"key": "@b", "type_system": "mssql", "type_id": "int", "json_type": "number", "component": "b-input", "input_type": "number", "constraints": {"multiple_of": null, "maximum": "2147483647", "exclusive_maximum": null, "minimum": "-2147483648", "exclusive_minimum": null, "max_length": 4, "min_length": null, "pattern": null, "max_items": null, "min_items": null, "unique_items": null, "max_properties": null, "min_properties": null, "required": null, "read_only": null, "write_only": null, "nullable": null, "enum": null, "validation_message": null, "step": "1"}, "object_property_schemas": null, "list_element_schema": null}, {"key": "@c", "type_system": "mssql", "type_id": "int", "json_type": "number", "component": "b-input", "input_type": "number", "constraints": {"multiple_of": null, "maximum": "2147483647", "exclusive_maximum": null, "minimum": "-2147483648", "exclusive_minimum": null, "max_length": 4, "min_length": null, "pattern": null, "max_items": null, "min_items": null, "unique_items": null, "max_properties": null, "min_properties": null, "required": null, "read_only": null, "write_only": null, "nullable": null, "enum": null, "validation_message": null, "step": "1"}, "object_property_schemas": null, "list_element_schema": null}, {"key": "@s", "type_system": "mssql", "type_id": "varchar", "json_type": "string", "component": "b-input", "input_type": "text", "constraints": {"multiple_of": null, "maximum": null, "exclusive_maximum": null, "minimum": null, "exclusive_minimum": null, "max_length": 25, "min_length": null, "pattern": null, "max_items": null, "min_items": null, "unique_items": null, "max_properties": null, "min_properties": null, "required": null, "read_only": null, "write_only": null, "nullable": null, "enum": null, "validation_message": null, "step": null}, "object_property_schemas": null, "list_element_schema": null}, {"key": "@d", "type_system": "mssql", "type_id": "float", "json_type": "number", "component": "b-input", "input_type": "number", "constraints": {"multiple_of": null, "maximum": null, "exclusive_maximum": null, "minimum": null, "exclusive_minimum": null, "max_length": 8, "min_length": null, "pattern": null, "max_items": null, "min_items": null, "unique_items": null, "max_properties": null, "min_properties": null, "required": null, "read_only": null, "write_only": null, "nullable": null, "enum": null, "validation_message": null, "step": "any"}, "object_property_schemas": null, "list_element_schema": null}]',
//     ol_id: "sandbox-119_561",
//   })
// ).legoDolls[0].kitRunSchema; //=

/*

888     888               888          888            
888     888               888          888            
888     888               888          888            
888     888 88888b.   .d88888  8888b.  888888 .d88b.  
888     888 888 "88b d88" 888     "88b 888   d8P  Y8b 
888     888 888  888 888  888 .d888888 888   88888888 
Y88b. .d88P 888 d88P Y88b 888 888  888 Y88b. Y8b.     
 "Y88888P"  88888P"   "Y88888 "Y888888  "Y888 "Y8888  
            888                                       
            888                                       
            888                                       

*/

function _planToUpdateLego(
  kd: CmdProcessed,
  old: LegoDoll,
  updated: LegoDoll
): KitDollPlan {
  const c = ocopy(kd);
  const [l, r] = odiffOldNew(old, updated, 0);
  const diff = r;
  if (pyfalsey(diff)) {
    return new KitDollPlan({ kitDoll: c });
  }

  const parallelRequests = [] as ApiRequest[];
  const legoFields = [
    "legoName",
    "legoDescription",
    "warningTag",
    "runButtonText",
    "runningMessage",
    "runOnStartup",
    "autocommit",
    "runOnStartupValues",
  ];
  const kitFields = ["directoryId"];
  const legoInstanceFields = ["kitRunSchema"];
  const legoDiff = okeyfilter(diff, (k) => legoFields.includes(k));
  const kitDiff = okeyfilter(diff, (k) => kitFields.includes(k));
  const legoInstanceDiff = okeyfilter(diff, (k) =>
    legoInstanceFields.includes(k)
  );
  // console.log("diff", diff); //=
  // console.log("legoInstanceDiff", legoInstanceDiff); //=
  // console.log("kitRunSchema l", l.kitRunSchema); //=
  if (pytruthy(legoDiff)) {
    parallelRequests.push({
      method: HttpMethod.PATCH,
      path: `command-templates/${updated.olId}`,
      body: omerge(
        "legoName" in diff ? { overrideName: diff.legoName } : {},
        "legoDescription" in diff ? { description: diff.legoDescription } : {},
        "warningTag" in diff ? { warningTag: diff.warningTag } : {},
        "runButtonText" in diff ? { runButtonText: diff.runButtonText } : {},
        "runningMessage" in diff ? { runningMessage: diff.runningMessage } : {},
        "runOnStartup" in diff ? { runOnStartup: diff.runOnStartup } : {},
        "runOnStartupValues" in diff
          ? {
              runOnStartupValues: runramsToStr(diff.runOnStartupValues),
            }
          : {},
        "autocommit" in diff ? { autocommit: diff.autocommit } : {}
      ),
      options: { orgPath: true },
    });
    if ("legoName" in diff) {
      parallelRequests.push({
        method: HttpMethod.PATCH,
        path: `skinny-kits/${c.kitId}`,
        body: { name: diff.legoName },
        options: { orgPath: true },
      });
      c.name = diff.legoName;
    }
  }
  if (pytruthy(kitDiff)) {
    if (c.legoDoll.olId === updated.olId) {
      parallelRequests.push({
        method: HttpMethod.PATCH,
        path: `skinny-kits/${c.kitId}`,
        body: { directoryId: diff.directoryId },
        options: { orgPath: true },
      });
      c.directoryId = diff.directoryId;
    }
  }
  let kitDollRequest = null as ApiRequest | null;
  if (pytruthy(legoInstanceDiff)) {
    const updatedInstanceSchema = trimDownSchema(updated.kitRunSchema, {
      from: "kitrun",
      to: "instance",
    });
    const oldInstanceSchema = trimDownSchema(old.kitRunSchema, {
      from: "kitrun",
      to: "instance",
    });
    const [inOldNotNew, inNewNotOld] = ldiffOrderInsensitive(
      oldInstanceSchema,
      updatedInstanceSchema,
      "key",
      "key"
    );
    const [inputsToAdd, inputsToUpdate] = lsplit(
      updatedInstanceSchema.map((el, i): [InstanceSchemaElement, number] => [
        el,
        i,
      ]),
      ([el, i]: [InstanceSchemaElement, number]) =>
        el.legoInstanceInputId === -1
    );
    const deleteRequests = inOldNotNew.map((element: InstanceSchemaElement) => {
      return {
        method: HttpMethod.DELETE,
        path: `kits/${c.kitId}/li-inputs/${element.legoInstanceInputId}`,
        options: { orgPath: true },
      };
    });
    parallelRequests.push(...deleteRequests);

    if (inputsToAdd.length > 0) {
      kitDollRequest = {
        method: HttpMethod.POST,
        path: `kits/${c.kitId}/lego-instance-inputs`,
        body: inputsToAdd.map(([el, i]: [InstanceSchemaElement, number]) => {
          return enforceType<ELegoInstanceInputPOSTReq>(
            omerge(instanceElementToLegoInstanceInputRow(el, i), {
              legoInstanceId: null,
              legoInput: enforceType<ELegoInstanceInputPOSTReq_LegoInput>(
                instanceElementToLegoInputRow(el, c.legoDoll.olId, i)
              ),
              kitId: c.kitId,
            })
          );
        }),
        callback: (resp: ELegoInstanceInputPOSTReq[]) => {
          c.legoDoll = updated;
          for (const [lii, el] of lzipBy(
            resp,
            c.legoDoll.kitRunSchema,
            (a, b) => a.key === b.key,
            {
              keepLeft: false,
              keepRight: false,
            }
          )) {
            el.legoInstanceInputId = lii.legoInstanceInputId;
            el.legoInputId = lii.legoInputId;
          }
          return { kitDoll: c };
        },
        options: { orgPath: true, isList: true },
      };
    }
  }

  if (kitDollRequest) {
    return new KitDollPlan({
      kitDollRequest: kitDollRequest,
      parallelRequests,
    });
  } else {
    c.legoDoll = updated;
    return new KitDollPlan({
      kitDoll: c,
      parallelRequests,
    });
  }
}

/*

8888888b.                                                   
888   Y88b                                                  
888    888                                                  
888   d88P .d88b.  88888b.d88b.   .d88b.  888  888  .d88b.  
8888888P" d8P  Y8b 888 "888 "88b d88""88b 888  888 d8P  Y8b 
888 T88b  88888888 888  888  888 888  888 Y88  88P 88888888 
888  T88b Y8b.     888  888  888 Y88..88P  Y8bd8P  Y8b.     
888   T88b "Y8888  888  888  888  "Y88P"    Y88P    "Y8888  
                                                            
                                                            
                                                            
*/

function _planToDeleteNotebookCell(
  kd: NotebookProcessed,
  kitInstanceId: number
): KitDollPlan {
  const c = ocopy(kd); // only make copy at root

  const idx = lfindIndex(
    c.cells ?? [],
    (k) => kitInstanceId === k.kitInstanceId
  );
  if (idx == -1) {
    return new KitDollPlan({ kitDoll: c });
  }

  const removedItem = ocopy(c.cells[idx]);
  c.cells = lremoveAt(c.cells, idx);
  const del = {
    method: HttpMethod.DELETE,
    path: `kits/${c.kitId}/kit_instances/${removedItem.kitInstanceId}`,
    options: { orgPath: true },
  };
  console.log("removedItem", removedItem);
  const orderPatches = lenumerate(c.cells)
    .slice(idx)
    .map(([idx, k]: [number, NotebookCellProcessed]) => ({
      method: HttpMethod.PATCH,
      path: `kits/${c.kitId}/kit_instances/${k.kitInstanceId}`,
      body: { order: idx },
      options: { orgPath: true },
    }));
  return new KitDollPlan({
    kitDoll: c,
    parallelRequests: [del, ...orderPatches],
  });
}
// // THIS WILL THROW AN ERROR
// // _planToDeleteNotebookCell({ kitInstanceId: "root" }, "root"); //=
// _planToDeleteNotebookCell({ kitInstanceId: "root" }, "nada"); //=
// // Remove lone LegoDoll from LegoKit with (no order patching)
// _planToDeleteNotebookCell(
//   { kitInstanceId: "root", kitId: 7, legoDolls: [{ legoInstanceId: 123 }] },
//   "root.li_123"
// ); //=
// // Remove lone CmdProcessed from kit with (no order patching)
// _planToDeleteNotebookCell(
//   {
//     kitInstanceId: "root",
//     kitId: 7,
//     cells: [{ kitInstanceId: 456, legoDolls: [{ legoInstanceId: 123 }] }],
//   },
//   "root.ki_456.li_123"
// ); //=
// // Order patching
// _planToDeleteNotebookCell(
//   {
//     kitInstanceId: "root",
//     kitId: 7,
//     cells: [
//       { kitInstanceId: 456, legoDolls: [{ legoInstanceId: 123 }] },
//       { kitInstanceId: 111, legoDolls: [{ legoInstanceId: 222 }] },
//       { kitInstanceId: 999, legoDolls: [{ legoInstanceId: 444 }] },
//     ],
//   },
//   "root.ki_456.li_123"
// ).parallelRequests; //=
// // Path to kit doll
// _planToDeleteNotebookCell(
//   {
//     kitInstanceId: "root",
//     kitId: 7,
//     cells: [
//       { kitInstanceId: 456, legoDolls: [{ legoInstanceId: 123 }] },
//       { kitInstanceId: 111, legoDolls: [{ legoInstanceId: 222 }] },
//       { kitInstanceId: 999, legoDolls: [{ legoInstanceId: 444 }] },
//     ],
//   },
//   "root.ki_456"
// ); //=

/*

 .d8888b.           888                                      
d88P  Y88b          888                                      
Y88b.               888                                      
 "Y888b.    .d8888b 88888b.   .d88b.  88888b.d88b.   8888b.  
    "Y88b. d88P"    888 "88b d8P  Y8b 888 "888 "88b     "88b 
      "888 888      888  888 88888888 888  888  888 .d888888 
Y88b  d88P Y88b.    888  888 Y8b.     888  888  888 888  888 
 "Y8888P"   "Y8888P 888  888  "Y8888  888  888  888 "Y888888 
                                                             
                                                             
                                                             

*/
function _planToUpdateSchemaElement(
  kd: CmdProcessed | NotebookProcessed,
  element: KitRunSchemaElement,
  kitInstanceId: number | null,
  elementPath: string,
  differentOrgId = "",
  skipDB = false
): KitDollPlan {
  // somewhere in here
  const c = ocopy(kd);
  const ref = _isCmd(c)
    ? (c as CmdProcessed).legoDoll
    : lfind(
        (c as NotebookProcessed).cells,
        (cell) => cell.kitInstanceId === kitInstanceId
      )?.legoDoll ?? null;
  if (ref === null) {
    return new KitDollPlan({ kitDoll: c });
  }
  ref.kitRunSchema = replaceElementInSchema(
    ref.kitRunSchema,
    elementPath,
    element
  );
  if (skipDB) {
    return new KitDollPlan({ kitDoll: c });
  }
  const parallelRequests = [] as ApiRequest[];
  if (!_isCmd(c)) {
    const cell = lfind(
      (c as NotebookProcessed).cells,
      (cell) => cell.kitInstanceId === kitInstanceId
    );
    if (!cell) {
      throw new Error("cell not found");
    }
    parallelRequests.push({
      method: HttpMethod.PATCH,
      path: `kits/${cell.kitId}/li-inputs/${element.legoInstanceInputId}`,
      body: enforceType<ELegoInstanceInputPATCHReq>(
        instanceElementToLegoInstanceInputRow(
          lfirst(
            trimDownSchema([element], {
              from: "kitrun",
              to: "instance",
            })
          )
        )
      ),
      options: { orgPath: true, orgId: differentOrgId },
    });
  } else {
    parallelRequests.push({
      method: HttpMethod.PATCH,
      path: `kits/${c.kitId}/li-inputs/${element.legoInstanceInputId}`,
      body: enforceType<ELegoInstanceInputPATCHReq>(
        instanceElementToLegoInstanceInputRow(
          lfirst(
            trimDownSchema([element], {
              from: "kitrun",
              to: "instance",
            })
          )
        )
      ),
      options: { orgPath: true, orgId: differentOrgId },
    });
  }
  return new KitDollPlan({ kitDoll: c, parallelRequests: parallelRequests });
}

// _planToUpdateSchemaElement(
//   {
//     kitInstanceId: "root",
//     kitId: 7,
//     legoDolls: [
//       {
//         legoInstanceId: 123,
//         kitRunSchema: [{ key: "name", value: "Jeremiah" }],
//       },
//     ],
//   },
//   { key: "name", value: "Jeffrey" },
//   "root.li_123",
//   "name"
// ).kitDoll.legoDolls[0]; //=

function _planToUpdateSchema(
  kd: CmdProcessed | NotebookProcessed,
  schema: KitRunSchemaElement[],
  kitInstanceId: number | null,
  differentOrgId = "",
  skipDB = false
): KitDollPlan {
  let c = ocopy(kd);
  if (_isCmd(c)) {
    c = c as CmdProcessed;
    c.legoDoll.kitRunSchema = schema;
    if (skipDB) {
      return new KitDollPlan({ kitDoll: c });
    }
    const instanceSchema = trimDownSchema(c.legoDoll.kitRunSchema, {
      from: "kitrun",
      to: "instance",
    });
    const elementPatches = instanceSchema.map(
      (element: InstanceSchemaElement) => {
        return {
          method: HttpMethod.PATCH,
          path: `kits/${c.kitId}/li-inputs/${element.legoInstanceInputId}`,
          body: enforceType<ELegoInstanceInputPATCHReq>(
            instanceElementToLegoInstanceInputRow(element)
          ),
          options: { orgPath: true, orgId: differentOrgId },
        };
      }
    );
    return new KitDollPlan({
      kitDoll: c,
      parallelRequests: elementPatches,
    });
  } else {
    c = c as NotebookProcessed;
    const cell = lfind(c.cells, (cell) => cell.kitInstanceId === kitInstanceId);
    if (!cell) {
      throw new Error("cell not found");
    }
    cell.legoDoll.kitRunSchema = schema;
    if (skipDB) {
      return new KitDollPlan({ kitDoll: c });
    }
    const instanceSchema = trimDownSchema(cell.legoDoll.kitRunSchema, {
      from: "kitrun",
      to: "instance",
    });
    const elementPatches = instanceSchema.map(
      (element: InstanceSchemaElement) => {
        return {
          method: HttpMethod.PATCH,
          path: `kits/${cell.kitId}/li-inputs/${element.legoInstanceInputId}`,
          body: enforceType<ELegoInstanceInputPATCHReq>(
            instanceElementToLegoInstanceInputRow(element)
          ),
          options: { orgPath: true, orgId: differentOrgId },
        };
      }
    );
    return new KitDollPlan({
      kitDoll: c,
      parallelRequests: elementPatches,
    });
  }
}
function _planToUpdateLegoInstanceInput(
  kd: CmdProcessed,
  legoInstanceInputId: number,
  partialLii: ELegoInstanceInputPATCHReq,
  {
    clearValue = false,
    kdCallback = (kd: CmdProcessed, lii: ELegoInstanceInputGET) => kd,
  }: {
    clearValue?: boolean;
    kdCallback?: (kd: CmdProcessed, lii: ELegoInstanceInputGET) => CmdProcessed;
  } = {}
): KitDollPlan {
  const c = ocopy(kd);
  const elementRef = lfind(
    c.legoDoll.kitRunSchema,
    (element) => element.legoInstanceInputId === legoInstanceInputId
  );
  if (!elementRef) {
    throw new Error("elementRef not found");
  }
  return new KitDollPlan({
    kitDollRequest: {
      method: HttpMethod.PATCH,
      path: `kits/${c.kitId}/li-inputs/${legoInstanceInputId}`,
      body: partialLii,
      options: { orgPath: true },
      callback: (resp: ELegoInstanceInputGET) => {
        const element = legoInstanceInputToInstanceSchemaElement(resp);
        Object.assign(elementRef, element);
        if (clearValue) {
          elementRef.value = elementEmptyValue(elementRef);
        }
        return {
          kitDoll: kdCallback(c, resp),
        };
      },
    },
  });
}

// 8888888b.                                888
// 888  "Y88b                               888
// 888    888                               888
// 888    888 888d888 .d88b.  88888b.   .d88888  .d88b.  888  888  888 88888b.
// 888    888 888P"  d88""88b 888 "88b d88" 888 d88""88b 888  888  888 888 "88b
// 888    888 888    888  888 888  888 888  888 888  888 888  888  888 888  888
// 888  .d88P 888    Y88..88P 888 d88P Y88b 888 Y88..88P Y88b 888 d88P 888  888
// 8888888P"  888     "Y88P"  88888P"   "Y88888  "Y88P"   "Y8888888P"  888  888
//                            888
//                            888
//                            888
function _planToUpdateDropdown(
  kd: CmdProcessed,
  dropdownId: number,
  legoInstanceInputId: number,
  body: EDropdownPATCHReq
): KitDollPlan {
  // TODO: if two elements in the same kit share a dropdown, this won't update both of them...
  const c = ocopy(kd);
  const elementRef = lfind(
    c.legoDoll.kitRunSchema,
    (el) => el.legoInstanceInputId === legoInstanceInputId
  );
  if (!elementRef) {
    throw new Error("elementRef not found");
  }
  if (
    "enum" in body &&
    !lcontains(JSON.parse(body?.enum ?? "[]"), elementRef.value, {
      looseEquality: true,
    })
  ) {
    elementRef.value = elementEmptyValue(elementRef);
  }
  const patch = {
    method: HttpMethod.PATCH,
    path: `dropdowns/${dropdownId}`,
    body: body,
    options: { orgPath: true },
    callback: (resp: EDropdownGET) => {
      const ddDoll = initDropdownDoll(resp);
      c.dropdowns[ddDoll.dropdownId] = ddDoll;
      return { kitDoll: c };
    },
  };
  return new KitDollPlan({ kitDollRequest: patch });
}
function _planToCreateDropdown(
  kd: CmdProcessed,
  enumArray: string[] | null,
  legoInstanceInputId: number,
  orgId: string,
  name: string,
  dynamicFields = {
    senderKitId: null,
    senderValueNoocId: null,
    senderDisplayNoocId: null,
    cacheInterval: null,
  } as {
    senderKitId: number | null;
    senderValueNoocId: number | null;
    senderDisplayNoocId: number | null;
    cacheInterval: "weekly" | "monthly" | null;
  }
): KitDollPlan {
  const c = ocopy(kd);

  const elementRef = lfind(
    c.legoDoll.kitRunSchema,
    (el) => el.legoInstanceInputId === legoInstanceInputId
  );
  if (!elementRef) {
    throw new Error("elementRef not found");
  }

  const dropdownPOST = {
    method: HttpMethod.POST,
    path: `dropdowns`,
    body: enforceType<EDropdownPOSTReq>({
      ...{
        name: name,
        enum: enumArray === null ? null : JSON.stringify(enumArray),
        orgId: orgId,
      },
      ...dynamicFields,
    }),
    options: { orgPath: true },
    callback: (ddResp: EDropdownPOSTResp) => {
      return {
        method: HttpMethod.PATCH,
        path: `kits/${c.kitId}/li-inputs/${legoInstanceInputId}`,
        body: enforceType<ELegoInstanceInputPATCHReq>({
          dropdownId: ddResp.dropdownId,
        }),
        options: { orgPath: true, orgId: orgId },
        callback: (resp: ELegoInstanceInputGET) => {
          const element = legoInstanceInputToInstanceSchemaElement(resp);
          Object.assign(elementRef, element);
          if (
            !lcontains(enumArray ?? [], elementRef.value, {
              looseEquality: true,
            })
          ) {
            elementRef.value = elementEmptyValue(elementRef);
          }
          const ddDoll = initDropdownDoll(resp.dropdown);
          c.dropdowns[ddDoll.dropdownId] = ddDoll;
          return { kitDoll: c };
        },
      };
    },
  };
  return new KitDollPlan({ kitDollRequest: dropdownPOST });
}
function _refreshDropdownsCallback(
  c: CmdProcessed,
  lii: ELegoInstanceInputGET
) {
  const ddDollIds: string[] = lunique(
    c.legoDoll.kitRunSchema
      .filter((el) => el.dropdownId !== null)
      .map((el) => (el.dropdownId as number).toString())
  );
  const [missing, toDelete] = ldiffOrderInsensitive(
    ddDollIds,
    okeysGen(c.dropdowns)
  );
  for (const ddId of toDelete) {
    delete c.dropdowns[ddId];
  }
  if (lii.dropdown?.dropdownId) {
    const liiDdDoll = initDropdownDoll(lii.dropdown);
    if (lcontains(missing, liiDdDoll.dropdownId.toString())) {
      c.dropdowns[liiDdDoll.dropdownId] = liiDdDoll;
    } else if (
      liiDdDoll.dropdownId in c.dropdowns &&
      !equals(liiDdDoll, c.dropdowns[liiDdDoll.dropdownId])
    ) {
      c.dropdowns[liiDdDoll.dropdownId] = liiDdDoll;
    }
  }
  return c;
}
function _planToUnlinkDropdown(
  kd: CmdProcessed,
  legoInstanceInputId: number
): KitDollPlan {
  return _planToUpdateLegoInstanceInput(
    kd,
    legoInstanceInputId,
    { dropdownId: null },
    { clearValue: false, kdCallback: _refreshDropdownsCallback }
  );
}
function _planToLinkDropdown(
  kd: CmdProcessed,
  legoInstanceInputId: number,
  dropdownId: number,
  { clearValue }: { clearValue?: boolean }
): KitDollPlan {
  return _planToUpdateLegoInstanceInput(
    kd,
    legoInstanceInputId,
    { dropdownId: dropdownId },
    { clearValue: clearValue, kdCallback: _refreshDropdownsCallback }
  );
}
/*

8888888                                    888    
  888                                      888    
  888                                      888    
  888   88888b.  .d8888b   .d88b.  888d888 888888 
  888   888 "88b 88K      d8P  Y8b 888P"   888    
  888   888  888 "Y8888b. 88888888 888     888    
  888   888  888      X88 Y8b.     888     Y88b.  
8888888 888  888  88888P'  "Y8888  888      "Y888 
                                                  
                                                  
                                                  

*/
function _planToUpdateDirectory(
  kd: CmdProcessed | NotebookProcessed,
  directoryId: number
): KitDollPlan {
  const c = ocopy(kd);
  const directoryPatch: ApiRequest = {
    method: HttpMethod.PATCH,
    path: `skinny-kits/${kd.kitId}`,
    body: { directoryId: directoryId },
    options: { orgPath: true },
  };
  c.directoryId = directoryId;
  return new KitDollPlan({
    kitDoll: c,
    parallelRequests: [directoryPatch],
  });
}
function _planToAppendCmdToNotebook(
  kd: NotebookProcessed,
  childKitId: number
): KitDollPlan {
  const request = {
    method: HttpMethod.POST,
    path: `kits/${kd.kitId}/kit_instances`,
    body: enforceType<EKitInstancePOSTReq>({
      parentKitId: kd.kitId,
      childKitId: childKitId,
      order: kd.cells?.length ?? 0,
    }),
    options: { orgPath: true },
    callback: (postResp: EKitInstancePOSTResp) => {
      return {
        method: HttpMethod.GET,
        path: `deep-kits-3/${childKitId}`,
        options: { orgPath: true },
        callback: (getResp: EDeepKit3GET) => {
          const cmdProcessed = _initKitDoll3(getResp);
          const { kitDoll } = _insertCmdInNotebook(
            kd,
            cmdProcessed as CmdProcessed,
            kd.cells?.length ?? 0,
            postResp.kitInstanceId
          );
          return {
            kitDoll: kitDoll,
          };
        },
      };
    },
  };
  return new KitDollPlan({ kitDollRequest: request });
}

function _insertCmdInNotebook(
  kd: NotebookProcessed,
  cmdProcessed: CmdProcessed,
  idx: number,
  kitInstanceId: number | null
): { kitDoll: NotebookProcessed; path?: string } {
  const c = ocopy(kd);
  const cell = omerge(cmdProcessed, {
    kitInstanceId: kitInstanceId,
    order: idx,
  });
  c.cells = lInsertAt(c.cells ?? [], idx, cell);
  for (let i = idx + 1; i < c.cells?.length; i++) {
    c.cells[i].order = i;
  }
  return { kitDoll: c };
}

/*

888     888 d8b          d8b 888      d8b 888 d8b 888             
888     888 Y8P          Y8P 888      Y8P 888 Y8P 888             
888     888                  888          888     888             
Y88b   d88P 888 .d8888b  888 88888b.  888 888 888 888888 888  888 
 Y88b d88P  888 88K      888 888 "88b 888 888 888 888    888  888 
  Y88o88P   888 "Y8888b. 888 888  888 888 888 888 888    888  888 
   Y888P    888      X88 888 888 d88P 888 888 888 Y88b.  Y88b 888 
    Y8P     888  88888P' 888 88888P"  888 888 888  "Y888  "Y88888 
                                                              888 
                                                         Y8b d88P 
                                                          "Y88P"  
*/

// TODO - Figure out whether to deprecate this
// (we now just make the API call in the side panel, for USSP)
// I think the SP should own the API call, but should it own the KB update too...?
// KB still uses this for the CcSP update
function _planToUpdateVisibility(
  kd: CmdProcessed | NotebookProcessed,
  visibility: KitVisibility
) {
  const request = {
    method: HttpMethod.PATCH,
    path: `skinny-kits/${kd.kitId}`,
    body: { visibility: visibility },
    options: { orgPath: true },
  };
  const c = ocopy(kd);
  c.visibility = visibility;

  return new KitDollPlan({ kitDoll: c, parallelRequests: [request] });
}

/*

 .d8888b.                           888                 888                                
d88P  Y88b                          888                 888                                
888    888                          888                 888                                
888        888d888 .d88b.   8888b.  888888 .d88b.       888      .d88b.   .d88b.   .d88b.  
888        888P"  d8P  Y8b     "88b 888   d8P  Y8b      888     d8P  Y8b d88P"88b d88""88b 
888    888 888    88888888 .d888888 888   88888888      888     88888888 888  888 888  888 
Y88b  d88P 888    Y8b.     888  888 Y88b. Y8b.          888     Y8b.     Y88b 888 Y88..88P 
 "Y8888P"  888     "Y8888  "Y888888  "Y888 "Y8888       88888888 "Y8888   "Y88888  "Y88P"  
                                                                              888          
                                                                         Y8b d88P          
                                                                          "Y88P"           
*/

function _planToCreateLego(
  kd: NotebookProcessed,
  lego: Body_create_lego_v1__org_id__command_templates_post
) {
  const request = {
    method: HttpMethod.POST,
    path: "legos",
    body: lego,
    options: { orgPath: true },
    callback: (kitId: number) => {
      return _planToAppendCmdToNotebook(kd, kitId).kitDollRequest;
    },
  };
  return new KitDollPlan({ kitDollRequest: request });
}

// 8888888b.                                            888    d8b
// 888  "Y88b                                           888    Y8P
// 888    888                                           888
// 888    888  .d88b.   .d8888b .d88b.  888d888 8888b.  888888 888  .d88b.  88888b.
// 888    888 d8P  Y8b d88P"   d88""88b 888P"      "88b 888    888 d88""88b 888 "88b
// 888    888 88888888 888     888  888 888    .d888888 888    888 888  888 888  888
// 888  .d88P Y8b.     Y88b.   Y88..88P 888    888  888 Y88b.  888 Y88..88P 888  888
// 8888888P"   "Y8888   "Y8888P "Y88P"  888    "Y888888  "Y888 888  "Y88P"  888  888

function _planToCreateDecoration(kd: CmdProcessed, body: EDecorationPOSTReq) {
  const request = {
    method: HttpMethod.POST,
    path: `kits/${kd.kitId}/decorations`,
    body: body,
    options: { orgPath: true },
    callback: (postResp: EDecorationPOSTResp) => {
      return {
        method: HttpMethod.GET,
        path: `kits/${kd.kitId}/decorations/${postResp.decorationId}`,
        options: { orgPath: true },
        callback: (getResp: EDecorationGET) => {
          const decorationDoll = _initDecorationDoll(getResp);
          const c = ocopy(kd);
          c.legoDoll.decorations.push(decorationDoll);
          return { kitDoll: c, decorationDoll: decorationDoll };
        },
      };
    },
  };
  return new KitDollPlan({ kitDollRequest: request });
}
function _planToDeleteDecoration(kd: CmdProcessed, decorationId: number) {
  const parallelRequest = {
    method: HttpMethod.DELETE,
    path: `kits/${kd.kitId}/decorations/${decorationId}`,
    options: { orgPath: true },
  };
  const c = ocopy(kd);
  c.legoDoll.decorations = c.legoDoll.decorations.filter(
    (d: DecorationDoll) => d.decorationId !== decorationId
  );
  return new KitDollPlan({ kitDoll: c, parallelRequests: [parallelRequest] });
}

function _planToUpdateDecoration(
  kd: CmdProcessed,
  decorationId: number,
  update: EDecorationPATCHReq
) {
  const c = ocopy(kd);
  const kitDollRequest = {
    method: HttpMethod.PATCH,
    path: `kits/${kd.kitId}/decorations/${decorationId}`,
    body: update,
    options: { orgPath: true },
    callback: (patchResp: EDecorationGET) => {
      c.legoDoll.decorations = lreplace(
        c.legoDoll.decorations,
        _initDecorationDoll(patchResp),
        "decorationId"
      );
      return { kitDoll: c };
    },
  };
  return new KitDollPlan({ kitDollRequest: kitDollRequest });
}
function _planToUpdateOutputColumns(kd: CmdProcessed, olId: string) {
  const request = {
    method: HttpMethod.GET,
    path: `kits/${kd.kitId}/ols/${olId}/output-cols`,
    options: { orgPath: true },
    callback: (getResp: ENotOurOutputColumnGET[]) => {
      kd.legoDoll.outputCols = getResp;
      return { kitDoll: kd };
    },
  };
  return new KitDollPlan({ kitDollRequest: request });
}
// 8888888          d8b 888
//   888            Y8P 888
//   888                888
//   888   88888b.  888 888888
//   888   888 "88b 888 888
//   888   888  888 888 888
//   888   888  888 888 Y88b.
// 8888888 888  888 888  "Y888
function _planToInitKitDoll3(kitId: number, orgId: string) {
  const request = {
    method: HttpMethod.GET,
    path: `deep-kits-3/${kitId}`,
    options: { orgPath: true, orgId: orgId },
    callback: (getResp: EDeepKit3GET) => {
      return { kitDoll: _initKitDoll3(getResp) };
    },
  };
  return new KitDollPlan({ kitDollRequest: request });
}

function _planToUpdateKitName(
  kd: CmdProcessed | NotebookProcessed,
  newName: string
): KitDollPlan {
  const c = ocopy(kd);
  c.name = newName;

  const parallelRequests: ApiRequest[] = [
    {
      method: HttpMethod.PATCH,
      path: `skinny-kits/${c.kitId}`,
      body: { name: newName },
      options: { orgPath: true },
    },
  ];

  // For CMD kits, also update the anchor lego name
  if (_isCmd(c)) {
    (c as CmdProcessed).legoDoll.legoName = newName;
    c.name = newName;
    parallelRequests.push({
      method: HttpMethod.PATCH,
      path: `command-templates/${(c as CmdProcessed).legoDoll.olId}`,
      body: enforceType<ELegoPATCHReq>({ overrideName: newName }),
      options: { orgPath: true },
    });
  }

  return new KitDollPlan({
    kitDoll: c,
    parallelRequests,
  });
}

export default {
  setCellLegoDoll: _setCellLegoDoll,
  isCmd: _isCmd,
  bindUrlParams: _bindUrlParams,
  addressAmbiguousParams: _addressAmbiguousParams,
  toQueryString: _toQueryString,
  toExcelFormula: _toExcelFormula,
  setDefaultValues: _setDefaultValues,
  setEnvVariableValues: _setEnvVariableValues,
  initKitDoll3: _initKitDoll3,
  planToAppendCmdToNotebook: _planToAppendCmdToNotebook,
  planToDeleteNotebookCell: _planToDeleteNotebookCell,
  planToUpdateLego: _planToUpdateLego,
  planToUpdateSchemaElement: _planToUpdateSchemaElement,
  planToUpdateSchema: _planToUpdateSchema,
  planToUpdateLegoInstanceInput: _planToUpdateLegoInstanceInput,
  planToUpdateDropdown: _planToUpdateDropdown,
  planToCreateDropdown: _planToCreateDropdown,
  planToUnlinkDropdown: _planToUnlinkDropdown,
  planToLinkDropdown: _planToLinkDropdown,
  planToSync: _planToSync,
  planToUpdateDirectory: _planToUpdateDirectory,
  initRecentKitDolls: _initRecentKitDolls,
  initPartialSkinnyKit: _initPartialSkinnyKit,
  initSkinnyKits: _initSkinnyKits,
  initSkinnyKitsOC: _initSkinnyKitsOC,
  initSkinnyKitsIC: _initSkinnyKitsIC,
  initSkinnyKitIC: _initSkinnyKitIC,
  planToUpdateVisibility: _planToUpdateVisibility,
  planToCreateLego: _planToCreateLego,
  planToCreateDecoration: _planToCreateDecoration,
  planToDeleteDecoration: _planToDeleteDecoration,
  planToUpdateDecoration: _planToUpdateDecoration,
  planToUpdateOutputColumns: _planToUpdateOutputColumns,
  planToInitKitDoll3: _planToInitKitDoll3,
  planToUpdateKitName: _planToUpdateKitName,
};

// https://patorjk.com/software/taag/#p=display&f=Colossal&t=Math
